// src/api/authFetch.js
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    ...options,
    headers,
    credentials: "same-origin",
  });

  // 🔴 여기서 공통 처리
  // 401(미인증) 공통 처리 [AUTH401_SILENT_V1]
  //   · 토큰이 아예 없으면(비로그인) → 조용히 응답만 반환
  //     비로그인에게는 서버(maskEstate)가 민감정보를 지워 보내므로
  //     "일부가 안 보이는 것"은 정상 동작이지 오류가 아니다.
  //   · 토큰이 있는데 401 이면(만료·무효) → 경고 후 예외
  //   · silent: true 를 넘기면 항상 조용히 처리
  if (res.status === 401) {
    if (!token || options.silent) {
      return res;   // 호출부에서 res.ok 로 판단해 해당 항목만 비우면 된다
    }
    alert("로그인이 필요한 서비스 입니다!");
    throw new Error("unauthorized");
  }

  return res;
}
